<template>
    <span v-if="todayIsBetweenDates(start, end)" class="mr-2">
        <badge class="todaybadge">
            {{ $t('vfair.activeNow') }}
        </badge>
    </span>
</template>

<script>
import Badge from './Badge.vue';

export default {
    name: 'OnGoingBadge',
    components: {
        Badge,
    },
    props: {
        start: {
            type: [String, Date],
            default: () => '',
        },
        end: {
            type: [String, Date],
            default: () => '',
        },
    },
    methods: {
        isToday(date) {
            let now = new Date();
            let then = new Date(date);

            return (
                then.getDate() === now.getDate() &&
                then.getMonth() === now.getMonth() &&
                then.getFullYear() === now.getFullYear()
            );
        },
        todayIsBetweenDates(_start, _end) {
            let today = new Date();
            let start = new Date(_start);
            let end = new Date(_end);

            return today >= start && today <= end;
        },
    },
};
</script>

<style scoped>
.todaybadge {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
}
</style>
